"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cw_google_analytics_1 = require("@dialogexe/cw-google-analytics");
function handleViewItemEvent(payload) {
    cw_google_analytics_1.onViewItem(payload.id, payload.name, payload.brand, payload.listName, payload.category);
}
exports.handleViewItemEvent = handleViewItemEvent;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-events/src/handlers/viewItem.ts